import dayjs, { Dayjs } from "utils/dayjs"

import { ApiLinkEntity, ApiLinkRel, AsyncReportState } from "config/constants"
import { Guid, IApiLink } from "@/types"
import StocktakingScope, { IGetStocktakingScopeDto } from "./StocktakingScope"
import { TenantWarehouse } from "./TenantWarehouse"

export interface IStocktakingOrderReport {
    uri?: string
    state: Omit<AsyncReportState,"canceledReportTooBig">
}

export enum StocktakingOrderStatus {
    requested = "requested",
    inProgress = "inProgress",
    closed = "closed",
}

export interface ICreateUpdateStocktakingOrderDto {
    dueDate: string
    note?: string | null
}

export interface IGetStocktakingOrderDto {
    id: Guid
    dueDate: string
    note?: string | null
    status: StocktakingOrderStatus
    closedWarehousesNumber: number
    createdByUserId: Guid
    submitDate: string
    stocktakingScopes: IGetStocktakingScopeDto[]
    closedByUserId?: Guid | null
    closedDate?: string | null
    initialReport?: IStocktakingOrderReport
    closingReport?: IStocktakingOrderReport
    links: IApiLink[]
}

export interface IStocktakingOrderAdditionalParams {
    tenantWarehouses: TenantWarehouse[]
    noWarehouseId: Guid
    emails: { [userId: string]: string }
}

export default class StocktakingOrder {
    id: Guid
    dueDate: Dayjs
    note?: string
    status: StocktakingOrderStatus
    submitDate: Dayjs
    stocktakingScopes: StocktakingScope[]
    createdBy?: string
    closedBy?: string
    closedDate?: Dayjs
    initialReport?: IStocktakingOrderReport
    closingReport?: IStocktakingOrderReport
    linkUpdate?: IApiLink
    linkDelete?: IApiLink
    linkClose?: IApiLink


    constructor(
        dto: IGetStocktakingOrderDto,
        params: IStocktakingOrderAdditionalParams
    ) {
        this.id = dto.id
        this.dueDate = dayjs(dto.dueDate, "YYYY-MM-DD")
        this.note = dto.note || undefined
        this.status = dto.status
        this.submitDate = dayjs(dto.submitDate)
        this.stocktakingScopes = dto.stocktakingScopes?.map(ss => {
            return new StocktakingScope(ss, {
                warehouseDescription: params.tenantWarehouses.find(tw => tw.id === ss.warehouseId)?.description || "",
                isNoWarehouse: ss.warehouseId === params.noWarehouseId,
                emails: params.emails,
            })
        }) || []
        this.createdBy = params.emails[dto.createdByUserId]
        this.closedBy = dto.closedByUserId ? params.emails[dto.closedByUserId] : undefined
        this.closedDate = dto.closedDate ? dayjs(dto.closedDate) : undefined
        this.initialReport = dto.initialReport
        this.closingReport = dto.closingReport
        this.linkUpdate = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.stocktakingOrder && lnk.rel === ApiLinkRel.update)
        this.linkDelete = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.stocktakingOrder && lnk.rel === ApiLinkRel.delete)
        this.linkClose = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.stocktakingOrderClose && lnk.rel === ApiLinkRel.update)
    }
}
